export function checkIsPrevDay(currentDate: Date, prevDate: Date): boolean {
  return (
    currentDate.getFullYear() === prevDate.getFullYear() &&
    currentDate.getMonth() === prevDate.getMonth() &&
    currentDate.getDate() > prevDate.getDate()
  );
}
